import {
  Component,
  Input,
  ChangeDetectionStrategy,
  computed,
  ChangeDetectorRef,
  inject,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventDetail } from '../../../core/models/event.models';

@Component({
  selector: 'app-event-hero',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './event-hero.component.html',
})
export class EventHeroComponent implements OnChanges {
  @Input({ required: true }) event!: EventDetail;

  private cdr = inject(ChangeDetectorRef);

  /** Capa primeiro, depois `event_images` por `position` (vem do mapper). */
  slides = computed(() => {
    const urls = this.event.heroCarouselUrls;
    return urls?.length ? urls : [this.event.bannerUrl];
  });

  carouselIndex = 0;
  showLightbox = false;

  openLightbox(): void {
    this.showLightbox = true;
    this.cdr.markForCheck();
  }

  closeLightbox(): void {
    this.showLightbox = false;
    this.cdr.markForCheck();
  }

  private date = computed(() => new Date(this.event.dateISO));
  day = computed(() => this.date().getDate().toString().padStart(2, '0'));
  month = computed(() =>
    new Intl.DateTimeFormat('pt-BR', { month: 'short' })
      .format(this.date())
      .replace('.', '')
      .toUpperCase(),
  );
  time = computed(() =>
    this.date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['event']) {
      this.carouselIndex = 0;
    }
  }

  prev(): void {
    const s = this.slides();
    if (s.length <= 1) return;
    this.carouselIndex = (this.carouselIndex - 1 + s.length) % s.length;
    this.cdr.markForCheck();
  }

  next(): void {
    const s = this.slides();
    if (s.length <= 1) return;
    this.carouselIndex = (this.carouselIndex + 1) % s.length;
    this.cdr.markForCheck();
  }
}
